
const DEMO_ASSETS = {
    hero1: 'https://siddhast.vercel.app/assets/images/hero-1.png',
    hero2: 'https://siddhast.vercel.app/assets/images/hero-2.png',
    hero3: 'https://siddhast.vercel.app/assets/images/hero-3.png'
  };
  const demoHeroSlides = [
    {
      image: DEMO_ASSETS.hero1,
      badge: 'About Siddhast',
      title: 'Trusted consulting & technology since 2005',
      text: 'Partnering with businesses, innovators, and institutions across India and the SAARC region to drive digital transformation and protect innovation.',
      url: 'about-us/index.html'
    },
    {
      image: DEMO_ASSETS.hero2,
      badge: 'Business Verticals',
      title: 'IT, IP & commercial solutions under one roof',
      text: 'Siddhast Innovation, Siddhast IP, and Siddhast Trade & Commerce deliver integrated advisory and technology services.',
      url: 'business/index.html'
    },
    {
      image: DEMO_ASSETS.hero3,
      badge: 'Innovation & Impact',
      title: 'Protecting ideas. Empowering growth.',
      text: 'From intellectual property strategy to sponsorships, leadership, and industry engagement — Siddhast builds long-term value through knowledge-driven solutions.',
      url: 'sponsorships/index.html'
    }
  ];
  let heroSlides = document.querySelectorAll('.hero-slide');
  let heroDots = document.querySelectorAll('#hero-dots .scroll-dot');
  const heroCurrent = document.getElementById('hero-current');
  const heroTotal = document.getElementById('hero-total');
  const progressBar = document.getElementById('hero-progress');
  let heroIndex = 0;
  let heroPaused = false;
  let heroTimer = null;
  const HERO_INTERVAL = Number(6000);
  function goToHero(idx) {
    if (!heroSlides.length) return;
    heroSlides[heroIndex].classList.remove('active');
    heroDots[heroIndex].classList.remove('active');
    heroIndex = (idx + heroSlides.length) % heroSlides.length;
    heroSlides[heroIndex].classList.add('active');
    heroDots[heroIndex].classList.add('active');
    if (heroCurrent) heroCurrent.textContent = heroIndex + 1;
    progressBar.style.transition = 'none';
    progressBar.style.width = '0%';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      progressBar.style.transition = `width ${HERO_INTERVAL}ms linear`;
      progressBar.style.width = '100%';
    }));
  }
  function startHeroAuto() {
    clearInterval(heroTimer);
    heroTimer = setInterval(() => { if (!heroPaused) goToHero(heroIndex + 1); }, HERO_INTERVAL);
    goToHero(heroIndex);
  }
  if (!heroSlides.length) {
    const heroSlider = document.getElementById('hero-slider');
    const heroDotsContainer = document.getElementById('hero-dots');
    if (heroSlider && heroDotsContainer) {
      heroSlider.innerHTML = demoHeroSlides.map((slide, index) => `
        <div class="hero-slide" data-index="${index}">
          <img src="${slide.image}" alt="${slide.title}" class="w-full h-full object-cover" />
          <div class="absolute inset-0 bg-black/35"></div>
          <div class="absolute inset-0 flex items-center">
            <div class="max-w-[1170px] mx-auto px-6 w-full">
              <div class="max-w-md">
                <span class="italic bg-brand-dark-deep text-white text-sm px-3 py-1.5 inline-block mb-3">${slide.badge}</span>
                <h1 class="text-white text-4xl md:text-5xl font-bold leading-tight mb-4">${slide.title}</h1>
                <div class="relative pl-8 ml-6">
                  <div class="absolute left-0 top-0 bottom-0 w-0.5 bg-brand-selection"></div>
                  <p class="text-white text-sm md:text-base font-medium mb-4 max-w-xs">${slide.text}</p>
                  <a href="${slide.url || '#'}" class="bg-brand-selection text-brand-dark text-sm px-4 py-2 inline-flex items-center gap-2 hover:bg-brand-selection-light transition-colors">Learn more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      `).join('');
      heroDotsContainer.innerHTML = demoHeroSlides.map(() => '<button class="scroll-dot"></button>').join('');
      heroSlides = document.querySelectorAll('.hero-slide');
      heroDots = document.querySelectorAll('#hero-dots .scroll-dot');
    }
  }
  if (heroSlides.length) {
    heroSlides.forEach((slide, index) => slide.classList.toggle('active', index === 0));
    heroDots.forEach((dot, index) => dot.classList.toggle('active', index === 0));
    if (heroTotal) heroTotal.textContent = String(heroSlides.length);
    document.getElementById('hero-prev')?.addEventListener('click', () => { goToHero(heroIndex - 1); startHeroAuto(); });
    document.getElementById('hero-next')?.addEventListener('click', () => { goToHero(heroIndex + 1); startHeroAuto(); });
    heroDots.forEach((dot, index) => dot.addEventListener('click', () => { goToHero(index); startHeroAuto(); }));
    document.getElementById('hero-pause')?.addEventListener('click', () => {
      heroPaused = !heroPaused;
      document.getElementById('pause-icon').textContent = heroPaused ? '>' : '||';
      if (!heroPaused) startHeroAuto();
    });
    startHeroAuto();
  }
  const careersGrid = document.getElementById('careers-grid');
  if (careersGrid && !careersGrid.querySelector('article')) {
    careersGrid.innerHTML = [
      ['INNOVANZA\'24 — BIET Jhansi', 'Siddhast supported innovation, IP awareness, and student engagement during the annual technical fest at Bundelkhand Institute of Engineering & Technology.', 'sponsorships/index.html'],
      ['National Conference on Innovations', 'Associated with national conferences at CSIR-NPL focused on science, engineering innovation, and indigenous research development.', 'sponsorships/index.html'],
      ['Reminiscence 2025 — KIET Alumni Meet', 'Sponsor of the KIET Deemed to be University alumni meet, reflecting Siddhast\'s continued connection with the KIET innovation ecosystem.', 'sponsorships/index.html']
    ].map(([title, text, url]) => `
      <article class="bg-white p-6 shadow">
        <h3 class="text-lg md:text-xl font-bold text-brand-dark mb-2"><a href="${url}">${title}</a></h3>
        <p class="text-brand-muted text-sm leading-relaxed">${text}</p>
      </article>
    `).join('');
  }
  let brandSlides = document.querySelectorAll('.brands-slide');
  let brandThumbs = document.querySelectorAll('.brand-thumb');
  let brandIndex = 0;
  function goToBrand(idx) {
    if (!brandSlides.length) return;
    brandSlides[brandIndex].classList.remove('active');
    brandThumbs[brandIndex]?.classList.remove('active');
    brandIndex = (idx + brandSlides.length) % brandSlides.length;
    brandSlides[brandIndex].classList.add('active');
    brandThumbs[brandIndex]?.classList.add('active');
  }
  if (!brandSlides.length) {
    const brandsSlider = document.getElementById('brands-slider');
    const brandStrip = document.getElementById('brand-strip');
    if (brandsSlider && brandStrip) {
      const demoBrands = [
        { image: DEMO_ASSETS.hero1, title: 'Siddhast Innovation', url: 'siddhast-innovation/index.html' },
        { image: DEMO_ASSETS.hero2, title: 'Siddhast IP', url: 'siddhast-intellectual-property-siddhast-ip/index.html' },
        { image: DEMO_ASSETS.hero3, title: 'Trade & Commerce', url: 'siddhast-trade-and-commerce/index.html' },
        { image: DEMO_ASSETS.hero2, title: 'BuckBuck', url: 'https://www.buckbuck.co.in' }
      ];
      brandsSlider.innerHTML = demoBrands.map((brand) => `
        <div class="brands-slide absolute inset-0">
          <a href="${brand.url}" class="block w-full h-full" target="${brand.url.startsWith('http') ? '_blank' : '_self'}" rel="${brand.url.startsWith('http') ? 'noopener noreferrer' : ''}">
            <img src="${brand.image}" alt="${brand.title}" class="w-full h-full object-cover" />
          </a>
        </div>
      `).join('');
      brandStrip.innerHTML = demoBrands.map((brand) => `
        <button class="brand-thumb">
          <img src="${brand.image}" alt="${brand.title}" class="w-20 h-12 md:w-28 md:h-16 object-cover" />
        </button>
      `).join('');
      brandSlides = document.querySelectorAll('.brands-slide');
      brandThumbs = document.querySelectorAll('.brand-thumb');
    }
  }
  if (brandSlides.length) {
    brandSlides.forEach((slide, index) => slide.classList.toggle('active', index === 0));
    brandThumbs.forEach((thumb, index) => thumb.classList.toggle('active', index === 0));
  }
  brandThumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      goToBrand(index);
    });
  });
  if (brandSlides.length) setInterval(() => goToBrand(brandIndex + 1), 4000);
/* Cookie consent — inline so Publii preview and static deploy always persist choice */
  (function () {
    if (window.__siddhastCookieBannerInit) return;
    window.__siddhastCookieBannerInit = true;

    var STORAGE_KEY = 'siddhast-cookie-consent';
    var MAX_AGE_DAYS = 365;
    var VALID = { accepted: true, declined: true };

    function cookieDomain() {
      var host = location.hostname;
      if (!host || host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return '';
      var parts = host.split('.');
      if (parts.length < 3) return '';
      return '; domain=.' + parts.slice(-2).join('.');
    }

    function setConsent(value) {
      if (!VALID[value]) return;
      try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
      try {
        var maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
        var expires = new Date(Date.now() + maxAge * 1000).toUTCString();
        var secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = STORAGE_KEY + '=' + encodeURIComponent(value) +
          '; path=/; max-age=' + maxAge + '; expires=' + expires +
          '; SameSite=Lax' + secure + cookieDomain();
      } catch (e) {}
      document.documentElement.setAttribute('data-cookie-consent', value);
    }

    function getConsent() {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + STORAGE_KEY + '=([^;]*)'));
      if (match) {
        var fromCookie = decodeURIComponent(match[1]);
        if (VALID[fromCookie]) return fromCookie;
      }
      try {
        var stored = localStorage.getItem(STORAGE_KEY);
        if (VALID[stored]) return stored;
      } catch (e) {}
      return null;
    }

    function hideBanner(banner) {
      banner.classList.add('is-hidden');
      banner.setAttribute('aria-hidden', 'true');
    }

    var existing = getConsent();
    if (existing) {
      document.documentElement.setAttribute('data-cookie-consent', existing);
    }

    function init() {
      var banner = document.getElementById('cookie-banner') || document.querySelector('.js-cookie-banner');
      if (!banner) return;
      var consent = getConsent();
      if (consent) {
        document.documentElement.setAttribute('data-cookie-consent', consent);
        hideBanner(banner);
        return;
      }
      var accept = document.getElementById('cookie-accept') || document.querySelector('.js-cookie-accept');
      var decline = document.getElementById('cookie-decline') || document.querySelector('.js-cookie-decline');
      function onChoice(value) {
        setConsent(value);
        hideBanner(banner);
      }
      if (accept) accept.addEventListener('click', function () { onChoice('accepted'); });
      if (decline) decline.addEventListener('click', function () { onChoice('declined'); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
/* ── Mobile Menu (inline so Publii preview always works) ── */
  (function () {
    if (window.__siddhastMobileMenuInit) return;
    window.__siddhastMobileMenuInit = true;
    var btn = document.getElementById('mobile-menu-btn');
    var menu = document.getElementById('mobile-menu');
    var overlay = document.getElementById('mobile-overlay');
    if (!btn || !menu || !overlay) return;
    if (menu.closest('#main-nav')) {
      var header = menu.closest('header');
      if (header) {
        header.appendChild(menu);
        header.appendChild(overlay);
      } else {
        document.body.appendChild(menu);
        document.body.appendChild(overlay);
      }
    }
    function setHamburger(open) {
      var hb1 = document.getElementById('hb1');
      var hb2 = document.getElementById('hb2');
      var hb3 = document.getElementById('hb3');
      if (hb1) hb1.style.transform = open ? 'rotate(45deg) translate(5px, 5px)' : '';
      if (hb2) hb2.style.opacity = open ? '0' : '1';
      if (hb3) hb3.style.transform = open ? 'rotate(-45deg) translate(5px, -5px)' : '';
    }
    function setOpen(open) {
      menu.classList.toggle('open', open);
      document.body.classList.toggle('mobile-menu-active', open);
      overlay.hidden = !open;
      overlay.style.display = open ? 'block' : 'none';
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      setHamburger(open);
    }
    function toggle() { setOpen(!menu.classList.contains('open')); }
    function close() { if (menu.classList.contains('open')) setOpen(false); }
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(); });
    overlay.addEventListener('click', function (e) { e.preventDefault(); close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    setOpen(false);
  })();

  /* ── Search Overlay ── */
  const searchOverlay = document.getElementById('search-overlay');
  const searchBtn = document.getElementById('search-btn');
  const searchClose = document.getElementById('search-close');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    const input = searchOverlay.querySelector('input[type="search"], input[type="text"]');
    if (input) setTimeout(() => input.focus(), 100);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }

  if (searchBtn && searchOverlay) searchBtn.addEventListener('click', () => {
    searchOverlay.classList.contains('open') ? closeSearch() : openSearch();
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  /* ── Google Site Search Handler ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList.contains('js-google-site-search')) return;
    e.preventDefault();
    var input = form.querySelector('input[type="search"], input[type="text"], input[name="gq"]');
    if (!input) return;
    var term = String(input.value || '').trim();
    if (!term) return;
    var raw = (form.getAttribute('data-site-domain') || '').trim();
    var domain = raw.replace(/^https?:\/\//i, '').split('/')[0].replace(/^www\./i, '');
    if (!domain) {
      var h = window.location.hostname;
      if (h && h !== 'localhost') domain = h.replace(/^www\./i, '');
    }
    if (!domain) {
      window.alert('Set your live domain under Site settings in Publii (Domain), or open this site from its real hostname so search can use site: filtering.');
      return;
    }
    var q = 'site:' + domain + ' ' + term;
    window.location.href = 'https://www.google.com/search?q=' + encodeURIComponent(q);
  }, false);

  /* ── Navbar Scroll Effect ── */
  const nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('is-scrolled', window.scrollY > 30);
    }, { passive: true });
  }